"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".mat-row[_ngcontent-%COMP%]{width:100%}.mat-table-content[_ngcontent-%COMP%]{width:100%;height:100%}.form-field[_ngcontent-%COMP%]{width:100%}"];
exports.styles = styles;
